import { SearchField } from "@heroui/react";
import type { SendReceiveHistoryType } from "@repo/api";

export type HistoryFilterBarProps = {
  type: SendReceiveHistoryType;
  uid: string;
  name: string;
  onUidChange: (value: string) => void;
  onNameChange: (value: string) => void;
  onSubmit?: () => void;
  className?: string;
};

export default function HistoryFilterBar({
  type,
  uid,
  name,
  onUidChange,
  onNameChange,
  onSubmit,
  className,
}: HistoryFilterBarProps) {
  const uidPlaceholder = type === "recive" ? "发货人UID" : "收货人UID";

  return (
    <div className={`flex flex-col sm:flex-row gap-2 items-stretch sm:items-center ${className ?? ""}`}>
      <SearchField
        variant="secondary"
        aria-label={uidPlaceholder}
        value={uid}
        onChange={onUidChange}
        onSubmit={onSubmit}
        className="w-full sm:w-70"
      >
        <SearchField.Group>
          <SearchField.SearchIcon />
          <SearchField.Input placeholder={uidPlaceholder} />
          <SearchField.ClearButton />
        </SearchField.Group>
      </SearchField>
      <SearchField
        variant="secondary"
        aria-label="模板名称"
        value={name}
        onChange={onNameChange}
        onSubmit={onSubmit}
        className="w-full sm:w-70"
      >
        <SearchField.Group>
          <SearchField.SearchIcon />
          <SearchField.Input placeholder="模板名称" />
          <SearchField.ClearButton />
        </SearchField.Group>
      </SearchField>
    </div>
  );
}
